import BaseService from "src/packages/BaseService";

export default class CompanyService extends BaseService {
	static get className() {
		return "company";
	}
};
